import { FormattedMessage } from 'react-intl';
import DOMPurify from 'dompurify';
import { StartButton } from './start-button';
import { AboutProgramProps } from './types';

export const AboutProgram = ({ program }: AboutProgramProps) => {
  const sanitizedDescription = DOMPurify.sanitize(program.description ?? '');
  return (
    <>
      <h3 className="m-2 py-2">
        <FormattedMessage
          id="payment.thankyou.product.about.program"
          defaultMessage="About Program"
          description="Product about section"
        />
      </h3>
      <div className="m-2 d-flex flex-column">
        <h4>{program.name}</h4>
        <div className="program-description tw-min-h-8 tw-max-h-40 tw-overflow-y-auto">
          <p
            className="m-0"
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{ __html: sanitizedDescription }}
          />
        </div>
      </div>

      <div className="row">
        <div className="mx-auto text-nowrap">
          <StartButton program={program} size="lg" block className="mt-1" />
        </div>
      </div>
    </>
  );
};
